module.exports = __webpack_public_path__ + "img/karpicko_2019_sm.2156669e.jpg";